import { GSTType } from './types';

// Indian numbering system — Lakhs/Crores
export function amountInWords(amount: number): string {
  if (amount === 0) return 'Rupees Zero Only';
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  function twoDigits(n: number): string {
    if (n < 20) return ones[n];
    return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + ones[n % 10] : '');
  }

  function threeDigits(n: number): string {
    if (n === 0) return '';
    if (n < 100) return twoDigits(n);
    return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + twoDigits(n % 100) : '');
  }

  const rupees = Math.floor(amount);
  const paise = Math.round((amount - rupees) * 100);

  let result = '';
  const crore = Math.floor(rupees / 10000000);
  const lakh = Math.floor((rupees % 10000000) / 100000);
  const thousand = Math.floor((rupees % 100000) / 1000);
  const remainder = rupees % 1000;

  if (crore > 0) result += threeDigits(crore) + ' Crore ';
  if (lakh > 0) result += threeDigits(lakh) + ' Lakh ';
  if (thousand > 0) result += threeDigits(thousand) + ' Thousand ';
  if (remainder > 0) result += threeDigits(remainder);

  result = result.trim();
  let final = 'Rupees ' + result;
  if (paise > 0) final += ' and ' + twoDigits(paise) + ' Paise';
  final += ' Only';
  return final;
}

export function formatINR(amount: number): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatINRCompact(amount: number): string {
  if (amount >= 10000000) return '₹' + (amount / 10000000).toFixed(2) + ' Cr';
  if (amount >= 100000) return '₹' + (amount / 100000).toFixed(2) + ' L';
  if (amount >= 1000) return '₹' + (amount / 1000).toFixed(1) + 'K';
  return '₹' + amount.toFixed(2);
}

export function todayDDMMYYYY(): string {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export function addDaysDDMMYYYY(dateStr: string, days: number): string {
  const parts = dateStr.split('/');
  if (parts.length !== 3) return dateStr;
  const d = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
  d.setDate(d.getDate() + days);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export function detectGSTType(city: string): GSTType {
  const delhiNCR = ['delhi', 'new delhi', 'noida', 'gurgaon', 'gurugram', 'faridabad', 'ghaziabad', 'greater noida', 'ncr'];
  const normalised = city.toLowerCase().trim();
  return delhiNCR.some((c) => normalised.includes(c)) ? 'CGST+SGST' : 'IGST';
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'Draft': return 'status-badge-draft';
    case 'Sent': return 'status-badge-sent';
    case 'Approved': return 'status-badge-approved';
    case 'Rejected': return 'status-badge-rejected';
    default: return 'status-badge-draft';
  }
}